import { Component } from 'preact';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../../Global/Icon';
import { compose } from 'recompose';
import { connect } from 'react-redux';
// Utils
import { actionHandler, stepHasRequiredData } from '../../../utilities/form/formUtils';

// Components
import Text from '../../Global/Text';

class Button extends Component {
  constructor(props) {
    super(props);
    this.setButton = this.setButton.bind(this);
    this.state = {
      active: false,
    };
  }

  setButton() {
    const { active } = this.state;
    this.setState({
      active: !active,
    });
  }

  render() {
    const { active } = this.state;
    const {
      id,
      label,
      actions,
      dispatch,
      variant,
      values,
      columns,
      type,
      tracking,
      requiredData,
      userData,
      inline,
      subType,
      setValues,
      className,
      dataTealium,
      additionalClassName,
      icon,
      hideButton,
      conditionalLabel,
      coverageAnchorIcon,
      packageData
    } = this.props;

    // If yes flow change required data
    let newRequiredData = {};
    if(packageData?.initialValues?.partnerNameSOFUS === "Finansforbundet") {
      let allof = requiredData?.allof;
      if(allof) {
        if(userData?.otherCompanyInsured === "yes-start-date-message") {
          const claimHistoryIndex = allof.findIndex(item => item.field === "Claim_History");
          if(claimHistoryIndex === -1) {
            allof.push({
              "field": "Claim_History",
              "type": "formValues",
              "value": true
            },
            {
              "field": "terminateAnyInsurance",
              "type": "userData",
              "value": true
            });
          }
          if(userData?.variableConsents) {
            userData.variableConsents.forEach(consent => {
              const terminateIndex = allof.findIndex(item => item.field === consent.id);
              if(terminateIndex === -1) {
                allof.push({
                  "field": consent.id,
                  "type": "formValues",
                  "value": true
                });
              }
            });
          }
        } else if(userData?.otherCompanyInsured === "no-start-date-message") {

          const claimHistoryIndex = allof.findIndex(item => item.field === "Claim_History");
          if(claimHistoryIndex !== -1) {
            allof.splice(claimHistoryIndex, 1);
          }
          const terminateIndex = allof.findIndex(item => item.field === "terminateAnyInsurance");
          if(terminateIndex !== -1) {
            allof.splice(terminateIndex, 1);
          }
          if(userData?.variableConsents) {
            allof = allof.filter(item => !item.field.includes("Terminate_Insurance"));
          }
        }
      }

      //BBR false
      if(userData) {
        if(userData?.bbrSuccess === false) {
          const bbrIndex = allof?.findIndex(item => item.field === "housingType");
          if(bbrIndex === -1) {
            allof.push({
                "field": "housingType",
                "type": "formValues",
                "notValue": ""
              },
              {
                "field": "roofType",
                "type": "formValues",
                "notValue": ""
              },
              {
                "field": "occupiedArea",
                "type": "formValues",
                "notValue": ""
              },
              {
                "field": "basementArea",
                "type": "formValues",
                "notValue": ""
              }
            );
          }
        } else {
          allof = allof?.filter(item => 
            !item.field === "housingType" || !item.field === "roofType" ||
            !item.field === "occupiedArea" || !item.field === "basementArea"
          );
        }
      }
    }
    
    newRequiredData = { ...requiredData };

    let isDisabled = !stepHasRequiredData(newRequiredData, userData, values);

    let newLabel = label;
    if(conditionalLabel) {
      const isDisabled2 = stepHasRequiredData(conditionalLabel.requiredData, userData, values);
      if(isDisabled2) {
        newLabel = conditionalLabel.label;
      }
      else if (!isDisabled2 && conditionalLabel.conditionalRequiredData && userData.registrationNumberValid !== null){
        isDisabled = !stepHasRequiredData(conditionalLabel.conditionalRequiredData, userData, values);
      }
    }

    const formFieldClass = classNames(
      'form__field', {
        'form__field--active': active,
        [`form__field--${id}`]: id,
        [`form__field--${type}`]: type,
        [`form__field--${type}-${variant}`]: type && variant,
        [`form__field--${columns}col`]: columns,
        [`${className}`]: className !== '',
      }
    );
    const buttonClass = classNames(
      'button', {
        'button--hide': isDisabled && hideButton,
        'button--disabled': isDisabled,
        'button--secondary': variant === 'button' && className === '',
        'button--primary': variant === 'button' && className !== '',
        [`button--${variant}`]: variant !== 'button',
        [`${additionalClassName}`]: additionalClassName !== '',
      },
      tracking
    );

    return (
      <div className={formFieldClass}>
        {inline &&
          <Text value={inline} component="span" className="button--inline" />
        }
        {icon ?
          <button
            type={subType}
            className={buttonClass}
            name={id}
            value={newLabel}
            disabled={isDisabled}
            onClick={e => actionHandler(actions, this.setButton, e, dispatch, values, setValues)}
            tabIndex={0}
            data-tealium={dataTealium}
            aria-label={newLabel}
          >
            <Icon icon={icon} />

          </button> :
          <>
            <button
              type={subType}
              className={buttonClass}
              name={id}
              value={newLabel}
              disabled={isDisabled}
              onClick={e => actionHandler(actions, this.setButton, e, dispatch, values, setValues)}
              tabIndex={0}
              data-tealium={dataTealium}
              aria-label={newLabel}
            >
              <Text value={newLabel} />
            </button>
            { coverageAnchorIcon.name &&
              <anchor-icon 
                className={coverageAnchorIcon.className}
                name={coverageAnchorIcon.name}
                size={coverageAnchorIcon.size}
                stroke={coverageAnchorIcon.stroke}
                onClick={e => actionHandler(actions, this.setButton, e, dispatch, values, setValues)}
              />
            }
            
          </>
        }
      </div>
    );
  }
}

// export default Button;
export default compose(
  connect(state => {
    const {
      section: {
        packageData
      },
    } = state;
    return {
      packageData
    };
  })
)(Button);

Button.defaultProps = {
  label: null,
  requiredData: null,
  values: null,
  tracking: ['tealiumSubmit'],
  variant: 'button',
  actions: [],
  userData: null,
  inline: null,
  className: '',
  subType: 'button',
  dataTealium: null,
  additionalClassName: '',
  icon: null,
  hideButton: false,
  id: "",
  coverageAnchorIcon: {}
};

Button.propTypes = {
  id: PropTypes.string,
  columns: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  values: PropTypes.object,
  type: PropTypes.string.isRequired,
  tracking: PropTypes.array,
  requiredData: PropTypes.object,
  actions: PropTypes.array,
  label: PropTypes.string,
  variant: PropTypes.string,
  userData: PropTypes.object,
  inline: PropTypes.string,
  setValues: PropTypes.func,
  className: PropTypes.string,
  subType: PropTypes.string,
  dataTealium: PropTypes.string,
  additionalClassName: PropTypes.string,
  icon: PropTypes.string,
  hideButton: PropTypes.bool,
  coverageAnchorIcon: PropTypes.object
};
